import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-mymo-business.component.scss';
var FormItemMymoBusiness = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemMymoBusiness, _super);
    function FormItemMymoBusiness(element) {
        var _this = _super.call(this, element) || this;
        _this.emailAddress = [
            {
                name: "Western_Cape",
                email: "enterprisedirect.westerncape@standardbank.co.za"
            }, {
                name: "Mpumalanga",
                email: "enterprisemp@standardbank.co.za"
            }, {
                name: "Eastern_Cape",
                email: "enterprisedirect.easterncape@standardbank.co.za"
            }, {
                name: "North_West",
                email: "directcst.northwest@standardbank.co.za"
            }, {
                name: "Free_State",
                email: "enterprisedirectfsnc@standardbank.co.za"
            }, {
                name: "Kwa_Zulu_Natal",
                email: "enterprisedirect.kzn@standardbank.co.za"
            }, {
                name: "Limpopo",
                email: "enterpriselp@standardbank.co.za"
            }, {
                name: "Northern_Cape",
                email: "enterprisedirectfsnc@standardbank.co.za"
            }, {
                name: "Ekurhuleni",
                email: "ekurhuleni.businessbanking@standardbank.co.za"
            }, {
                name: "CityOfJohannesburg",
                email: "COJ.businessbanking@standardbank.co.za"
            }, {
                name: "CityOfTshwane",
                email: "tshwane.businessbanking@standardbank.co.za"
            }, {
                name: "MetswedingDistrict",
                email: "tshwane.businessbanking@standardbank.co.za"
            }, {
                name: "SedibengDistrict",
                email: "ekurhuleni.businessbanking@standardbank.co.za"
            }, {
                name: "WestRandDistrict",
                email: "coj.businessbanking@standardbank.co.za"
            }
        ];
        return _this;
    }
    FormItemMymoBusiness.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now__button-business_dfc"));
        this.businessReg = this.element.querySelector('.form__input--busReg');
        this.saID = this.element.querySelector(".js-input__saId");
        this.province = this.element.querySelector("select[name=province]");
        this.city = this.element.querySelector("select[name=city]");
        this.businessType = this.element.querySelector(".js-business-type");
        if (this.businessType) {
            this.validateBusinessType(this.businessType.value);
        }
        this.closeButton = Array.from(this.element.querySelectorAll('.js-mymo__close-modal'));
    };
    FormItemMymoBusiness.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.businessType) {
            this.businessType.addEventListener("change", function () { return _this.validateBusinessType(_this.businessType.value); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
            // Reset the form
            this.form.addEventListener('custom_form_reset_event', function (e) {
                var thankYou = _this.form.querySelector(".form__thankyou--container");
                if (thankYou) {
                    thankYou.classList.remove('active');
                }
                var valid = Array.from(_this.form.querySelectorAll('.form__group--error'));
                valid.map(function (pElem) {
                    pElem.classList.remove('form__group--error');
                    var errorMessage = pElem.querySelector('.form__group--error_message');
                    if (errorMessage) {
                        errorMessage.remove();
                    }
                });
                _this.resetForm();
            }, false);
        }
        // This adds slashes to the business registration number
        if (this.businessReg) {
            this.businessReg.addEventListener('input', function (event) {
                if ((event.inputType !== 'deleteContentBackward') && (event.inputType !== 'deleteContentForward')) {
                    var reg = event.target.value;
                    event.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            this.businessReg.addEventListener('blur', function (event) {
                var reg = event.target.value;
                event.target.value = _this.validationService.formatExpression(reg);
            });
        }
        if (this.province) {
            this.province.addEventListener("change", function (pEvent) {
                var _target = pEvent.target;
                var _formGroup = _this.city.closest(".form__group");
                if (_formGroup) {
                    if (_target.value === "Gauteng") {
                        _this.city.classList.add("form__input--required");
                        _formGroup.classList.remove("form__group--hidden");
                    }
                    else {
                        _this.city.classList.remove("form__input--required");
                        _this.city.value = "";
                        _formGroup.classList.add("form__group--hidden");
                    }
                }
            });
        }
        if (this.closeButton) {
            this.closeButton.map(function (item) { return item.addEventListener('click', function (event) {
                _this.closeModals();
            }); });
        }
    };
    FormItemMymoBusiness.prototype.updateSuccessEmail = function (pProvince, pId, pCity, split) {
        if (pCity === void 0) { pCity = null; }
        var _searchString = "";
        if ((pProvince !== "Gauteng") && !pCity) {
            _searchString = pProvince;
        }
        else {
            _searchString = pCity;
        }
        var _emailAddress = "";
        if (split === "CST") {
            for (var i = 0; i < this.emailAddress.length; i++) {
                if (this.emailAddress[i].name === _searchString) {
                    _emailAddress = this.emailAddress[i].email;
                    break;
                }
            }
        }
        else {
            _emailAddress = "smallenterprisesales@standardbank.co.za";
        }
        var _emailLink = this.element.querySelector("span.js-mymo-business__email");
        _emailLink.innerHTML = '';
        var _subject = "Documentation for application: " + pId;
        var _body = "To Whom It May Concern\n\nAttached please find a copy of the following documents as requested:\n\nID of owners and signatories\nProof of address not older than 3 months\nCompany registration documents if a registered company";
        var _mailToText = "mailto:" + _emailAddress + "?subject=" + encodeURIComponent(_subject) + "&body=" + encodeURIComponent(_body);
        var _newButton = document.createElement("a");
        _newButton.textContent = _emailAddress;
        _newButton.setAttribute("data-id", "link_content_ documents email click");
        _newButton.setAttribute("data-text", "email documents button click");
        _newButton.setAttribute("href", _mailToText);
        _emailLink.appendChild(_newButton);
    };
    FormItemMymoBusiness.prototype.validateBusinessType = function (type) {
        this.updateFormView();
        switch (type) {
            case "Private Company":
            case "Close Corporation":
                if (this.saID && this.businessReg) {
                    this.saID.classList.remove("form__group--error");
                    this.saID.classList.add("form__group--hidden");
                    var _idGroup = this.saID.querySelector(".form__group--error_message");
                    if (_idGroup) {
                        this.saID.removeChild(_idGroup);
                    }
                    var _idField = this.saID.querySelector("input");
                    _idField.classList.remove("form__input--required");
                    _idField.value = "";
                    var _businessGroup = this.businessReg.closest(".form__group");
                    _businessGroup.classList.remove("form__group--error");
                    _businessGroup.classList.remove("form__group--hidden");
                    this.businessReg.classList.add("form__input--required");
                }
                break;
            case "Other":
                this.updateFormView();
                break;
            default:
                if (this.saID && this.businessReg) {
                    this.saID.classList.remove("form__group--error");
                    this.saID.classList.remove("form__group--hidden");
                    var _idField = this.saID.querySelector("input");
                    _idField.classList.add("form__input--required");
                    var _businessGroup = this.businessReg.closest(".form__group");
                    _businessGroup.classList.remove("form__group--error");
                    _businessGroup.classList.add("form__group--hidden");
                    this.businessReg.classList.remove("form__input--required");
                    this.businessReg.value = "";
                    var _idGroup = _businessGroup.querySelector(".form__group--error_message");
                    if (_idGroup) {
                        _businessGroup.removeChild(_idGroup);
                    }
                }
                break;
        }
    };
    FormItemMymoBusiness.prototype.closeModals = function () {
        var _allModals = Array.from(document.querySelectorAll('.js-apply-now-modal'));
        _allModals.forEach(function (_modal) {
            _modal.classList.add('modal--closed');
            _modal.classList.remove('modal--close');
        });
    };
    FormItemMymoBusiness.prototype.updateFormView = function () {
        var formGroup = this.businessType.closest(".form__group");
        var formGroups = Array.from(this.element.querySelectorAll(".form__group"));
        var formNote = this.element.querySelector(".apply-now__note");
        var formButtons = this.element.querySelector(".apply-now__buttons");
        var formOtherContainer = this.element.querySelector(".form__business-other--container");
        if (this.businessType.value === "Other") {
            formGroups.map(function (item) {
                item.classList.add("form__group--hidden");
            });
            formNote.classList.add("hidden");
            formButtons.classList.add("hidden");
            if (formOtherContainer) {
                formOtherContainer.classList.add("active");
            }
        }
        else {
            formGroups.map(function (item) {
                if (!item.classList.contains("js__noChange")) {
                    item.classList.remove("form__group--hidden");
                }
            });
            formNote.classList.remove("hidden");
            formButtons.classList.remove("hidden");
            if (formOtherContainer) {
                formOtherContainer.classList.remove("active");
            }
        }
        formGroup.classList.remove("form__group--hidden");
    };
    FormItemMymoBusiness.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var thankYouDfc = form.querySelector(".form__thankyou--container_dfc");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // fields
        var enquiryType = form.querySelector("select[name=enquiry-type]");
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/mymobusinessForm.jsp";
        var postData = "";
        var _split = "CST";
        postData += "splitFlag=CST";
        var _description = form.querySelector("input[name=description]");
        postData += "&description=" + (_description ? _description.value : "MYMO BUSINESS CURRENT ACCOUNT");
        var _firstName = form.querySelector("input[name=first-name]");
        postData += "&firstname=" + (_firstName ? _firstName.value : "");
        var _lastName = form.querySelector("input[name=last-name]");
        postData += "&surname=" + (_lastName ? _lastName.value : "");
        var _businessType = form.querySelector("select[name=business-type]");
        postData += "&businessType=" + (_businessType ? _businessType.value : "");
        var _phoneNumber = form.querySelector("input[name=phone-number]");
        postData += "&contactNo=" + (_phoneNumber ? _phoneNumber.value : "");
        var _altPhoneNumber = form.querySelector("input[name=alternative-number]");
        postData += "&altContactNo=" + (_altPhoneNumber ? _altPhoneNumber.value : "");
        var _email = form.querySelector("input[name=email-address]");
        postData += "&emailAddress=" + (_email ? _email.value : "");
        var _businessRegNumber = form.querySelector("input[name=business-reg-number]");
        postData += "&businessRegNumber=" + (_businessRegNumber ? _businessRegNumber.value : "");
        var _idNumber = form.querySelector("input[name=id-number]");
        postData += "&idNumber=" + (_idNumber ? _idNumber.value : "");
        var _province = form.querySelector("select[name=province]");
        postData += "&province=" + (_province ? _province.value : "");
        var _city = form.querySelector("select[name=city]");
        postData += "&city=" + (_province ? (_province.value === "Gauteng" ? (_city ? _city.value : "") : "") : "");
        var _existingCustomer = form.querySelector("input[name=existing-customer]");
        var _answer = (_existingCustomer ? (_existingCustomer.checked ? "YES" : "NO") : "NO");
        postData += "&isExistingCustomer=" + _answer;
        var _popiConsent = form.querySelector("input[name=popi-consent]");
        var _popiConsentAnswer = (_popiConsent ? (_popiConsent.checked ? "YES" : "NO") : "NO");
        postData += "&popiConsent=" + _popiConsentAnswer;
        postData += "&source=" + this.formsService.isMobile();
        // service
        this.formsService.postForm(url, postData).then(function (response) {
            // service ok
            loader.classList.remove("active");
            if (response.data === "invalid") {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                fieldsContainer.classList.remove("hidden");
            }
            else {
                analyticsService.dtmFormComplete("complete", response.data);
                thankYou.classList.add("active");
                _this.updateSuccessEmail(_province.value, _idNumber.value, _city.value, _split);
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
        });
    };
    FormItemMymoBusiness.prototype.resetForm = function () {
        this.businessType.value = "";
        this.validateBusinessType(this.businessType.value);
    };
    return FormItemMymoBusiness;
}(Base));
export { FormItemMymoBusiness };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-mymo-business/form-item-mymo-business.component.ts
// module id = 953
// module chunks = 0